export const navigation = {
	'#aboutUs': 'O nás',
	'#services': 'Služby',
	'#references': 'Referencie',
	'#career': 'Kariéra',
	'#contact': 'Kontakt',
};
